import React from 'react';

import APPCONFIG from "constants/Config";

import Framework from "@beardeddevops/react.framework";
import {Breadcrumb, Collections} from "components";

export default class Account_Activity extends Framework.Components.View {
	render() {
		return (
			<div className="container-fluid">
				<div className="page-bar">
					<ul className="page-breadcrumb">
						<Breadcrumb name="Account Activity" url="/account_activity" icon="line-chart"/>
					</ul>
				</div>

				<Framework.Errors.General isDev={APPCONFIG.settings.isDev()}>
					<section className="mb-4">
						<h4>New Customer Signups</h4>
						<p>One row per customer account, newest first, with current locations, plans, and active-user count.</p>
						<Collections.AccountSignups
							history={this.props.history}
							reloadShell={this.props.reloadShell}
							reloadPage={this.refreshPage}
							reloadSelf={this.state.refresh}
						/>
					</section>

					<section>
						<h4>Stripe Subscriptions</h4>
						<p>
							Every subscription from the Stripe subscription snapshot, newest first. Quantity, plan, amount, status, and billing-period dates make new subscriptions and account growth visible.
						</p>
						<Collections.StripeSubscriptions
							history={this.props.history}
							reloadShell={this.props.reloadShell}
							reloadPage={this.refreshPage}
							reloadSelf={this.state.refresh}
						/>
					</section>
				</Framework.Errors.General>
			</div>
		);
	}
}
